import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get, map, forEach, filter, size } from "lodash";

import FormSection from "../Common/FormSection";
import { driveInOut, trainInOut, walkInOut } from "../../constants/reducers";

const SiteEntranceExitForm = (props) => {
  const { siteEntranceExit, companies, section } = props;
  const [options, setOptions] = useState();

  const activeSite = get(siteEntranceExit, [section, "activeSite"]);

  useEffect(() => {
    // console.log("SiteEntranceExitForm >> Setting/Changing options.")
    setOptions(filter(
      map(companies, (c) => ({
        ...c,
        options: filter(
          get(c, ["sites"]),
          (s) =>
            size(
              filter(s.zones, (z) => section === driveInOut
                ? get(z, ["is_vehicle_access"])
                : section === walkInOut
                ? get(z, ["is_human_access"])
                : section === trainInOut
                ? get(z, ["is_train_access"])
                : true
              )
            ) > 0
        ),
      })),
      (item) => size(get(item, ["options"])) > 0
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, section]);

  const handleChange = (id, index, value) => {
    let site;
    forEach(companies, (c) => {
      forEach(get(c, ["sites"]), (s) => {
        if (s.id === value) {
          site = s;
        }
      });
    });
    let siteId = parseInt(get(site, ["id"]));
    props.history.push(`/siteEntranceExit/${section}/site/${siteId}`);
  };

  return (
    <>{options && 
      // If the options aren't ready yet, don't put in a control that 
      // depends on them.
      <FormSection
        formValue={[get(activeSite, ["id"]) || ""]}
        setFormValue={handleChange}
        title={"site"}
        id={"site"}
        type="select"
        options={{
          categories: true,
          options,
        }}
      />
    }</>
  );
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: state.siteEntranceExit,
    companies: get(state, ["user", "companies"]),
  };
};

export default withRouter(connect(mapStateToProps)(SiteEntranceExitForm));
